var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "el-form",
            {
              ref: "formSearch",
              attrs: {
                model: _vm.queryForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.ReturnTime") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.queryDateTime,
                              callback: function ($$v) {
                                _vm.queryDateTime = $$v
                              },
                              expression: "queryDateTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("collectionCenter.region") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("placeOrder.pleaseChoose"),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.regionId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "regionId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.regionId",
                              },
                            },
                            _vm._l(_vm.regionList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.zhName + "（" + item.puName + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.stateSite1"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.queryForm.params.stateList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "stateList",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.stateList",
                              },
                            },
                            _vm._l(_vm.StateList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.Outlets") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.queryForm.params.siteIdList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "siteIdList",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.siteIdList",
                              },
                            },
                            _vm._l(_vm.siteList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "collectionCenter.owningTransitCenter1"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("GlobalSetObj.all"),
                                clearable: "",
                                "collapse-tags": "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.queryForm.params.transitCenterIdList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "transitCenterIdList",
                                    $$v
                                  )
                                },
                                expression:
                                  "queryForm.params.transitCenterIdList",
                              },
                            },
                            _vm._l(_vm.TransferList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-search",
                              size: "small",
                              type: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.searchResources(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("operationCenter.Procurar")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: {
                              icon: "el-icon-upload2",
                              size: "small",
                              type: "primary",
                            },
                            on: { click: _vm.allExportOrder },
                          },
                          [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              icon: "el-icon-refresh-left",
                              size: "small",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.searchResources(2)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("operationCenter.reset")) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.diffExportOrder },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("tablePrice.exportDiscrepancyDetails")
                              ) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-radio-group",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { size: "small" },
                            on: {
                              change: function ($event) {
                                return _vm.searchResources(1)
                              },
                            },
                            model: {
                              value: _vm.queryForm.params.isTest,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "isTest", $$v)
                              },
                              expression: "queryForm.params.isTest",
                            },
                          },
                          [
                            _c("el-radio-button", { attrs: { label: 1 } }, [
                              _vm._v(_vm._s(_vm.$t("newOrder.Formal"))),
                            ]),
                            _c("el-radio-button", { attrs: { label: 2 } }, [
                              _vm._v(_vm._s(_vm.$t("newOrder.test1"))),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "80",
            },
          }),
          _vm._l(_vm.columnList, function (item, ind) {
            return _c(
              "el-table-column",
              {
                key: ind,
                attrs: {
                  align: item.align,
                  "min-width": item.width,
                  prop: item.prop,
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.strARR.includes(item.prop)
                            ? _c(
                                "div",
                                {
                                  class: _vm.strARR.includes(item.prop)
                                    ? "table-active"
                                    : "",
                                  on: {
                                    click: function ($event) {
                                      return _vm.seeDetial(
                                        scope.row,
                                        item.prop,
                                        scope.row[item.prop],
                                        item.typeNum
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(scope.row[item.prop] || 0) +
                                      " "
                                  ),
                                ]
                              )
                            : _c("div", [_vm._v(_vm._s(scope.row[item.prop]))]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _c("template", { slot: "header" }, [
                  _c("div", [_vm._v(_vm._s(item.label))]),
                ]),
              ],
              2
            )
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              "current-page": _vm.queryForm.pageNumber,
              "page-size": _vm.queryForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.getCurrentTableData,
              "size-change": _vm.getSizeTableData,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.$t("customerManagements.detailTitle"),
            visible: _vm.dialogVisible,
            center: "",
            direction: "ltr",
            size: "1200px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeDrawer,
          },
        },
        [
          _vm.dialogVisible
            ? _c("packageDetail", {
                ref: "votesDetails",
                attrs: { dataobj: _vm.dataObj },
                on: { "call-parent-method": _vm.parentMethod },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }